import { render, staticRenderFns } from "./confirmEmail.vue?vue&type=template&id=977fbad0"
import script from "./confirmEmail.vue?vue&type=script&lang=js"
export * from "./confirmEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports